var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("stripe-element-card", {
    ref: "element",
    staticClass: "lib-stripe-card",
    attrs: { pk: _vm.pk, "element-style": _vm.style },
    on: {
      token: function ($event) {
        return _vm.promiseFunctions.resolve($event)
      },
      error: function ($event) {
        return _vm.promiseFunctions.reject($event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "stripe-element-errors",
        fn: function () {
          return [
            _c("div", {
              staticClass: "lib-form-error",
              attrs: { id: "stripe-element-errors", role: "alert" },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }